import { me } from "flavours/glitch/initial_state";

// Drafts live in the browser's localStorage, one list per account. Uploaded
// attachments are kept as references (the files stay on the server).

const MAX_DRAFTS = 50;
const storageKey = () => `sloth_drafts:${me || "guest"}`;

export const loadDrafts = () => {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey()));
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

const storeDrafts = (drafts) => {
  try {
    localStorage.setItem(storageKey(), JSON.stringify(drafts));
    return true;
  } catch {
    return false;
  }
};

// Replaces the draft with the same id or adds a new one at the top.
// Returns false if the browser refused to store it.
export const saveDraft = (draft) => {
  const others = loadDrafts().filter(item => item.id !== draft.id);
  return storeDrafts([draft, ...others].slice(0, MAX_DRAFTS));
};

export const removeDraft = (id) => storeDrafts(loadDrafts().filter(item => item.id !== id));

export const clearDrafts = () => storeDrafts([]);
